/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sponsor_Edit_ChangeInputs */



/**
* | output |
* | --- |
* | "Change sponsor" |
*
* @param {Sponsor_Edit_ChangeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sponsor_edit_change = /** @type {((inputs?: Sponsor_Edit_ChangeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sponsor_Edit_ChangeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Changer de parrain")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cambiar avalista")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Alterar padrinho")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cambia sponsor")
	return /** @type {LocalizedString} */ ("Change sponsor")
});